module.exports = __webpack_public_path__ + "img/confirm-vote.9f7ca127.png";